import React from "react";
import { InputNumber } from "antd";
import { DollarSign, Percent } from "lucide-react";

interface ChargesAndDiscountsProps {
  cartTotal: number;
  otherCharges: number;
  setOtherCharges: (val: number) => void;
  discount: number;
  setDiscount: (val: number) => void;
}

export const ChargesAndDiscounts: React.FC<ChargesAndDiscountsProps> = ({
  cartTotal,
  otherCharges,
  setOtherCharges,
  discount,
  setDiscount,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      {[
        {
          label: "Other Charges",
          icon: <DollarSign className="w-3 h-3 text-emerald-500" />,
          val: otherCharges,
          set: setOtherCharges,
          max: undefined,
        },
        {
          label: "Discount",
          icon: <Percent className="w-3 h-3 text-red-500" />,
          val: discount,
          set: setDiscount,
          max: cartTotal,
        },
      ].map(({ label, icon, val, set, max }) => (
        <div key={label} className="flex flex-col gap-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1">
            {icon}
            {label}
          </label>
          <InputNumber
            value={val}
            onChange={(v) => set(v || 0)}
            min={0}
            max={max}
            size="middle"
            className="w-full rounded-md text-xs border-gray-200"
            formatter={(v) => `LKR ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(v) => v!.replace(/LKR\s?|(,*)/g, "") as any}
          />
        </div>
      ))}
    </div>
  );
};
